import * as React from 'react';
import { IgcSelectHeaderComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * Represents a header item in an igc-select component.
 * @slot  - Renders the header.
 * @class
 */
export const IgrSelectHeader = /* @__PURE__ */ createComponent({
  tagName: 'igc-select-header',
  displayName: 'IgrSelectHeader',
  elementClass: Component,
  react: React,
});

export type IgrSelectHeader = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrSelectHeaderModule = Component;
